import * as XLSX from "xlsx";

export type RowData = { [key: string]: any }; // Defina o tipo RowData de forma genérica

/* Função para calcular a largura das colunas */
const getWithColsExportExcel = <T extends RowData>(
  header: string[],
  rows: T[]
) => {
  return header.map((headerItem, index) => {
    // Obter o comprimento do item de cabeçalho
    const headerLength = headerItem.length;
    // Acesse a propriedade pela chave RowData
    const maxContentLength = Math.max(
      ...rows.map((row) => {
        const key = Object.keys(row)[index] as keyof T;
        return row[key] ? row[key].toString().length : 0;
      })
    );
    // Retorna o maior dos dois (cabeçalho ou dados)
    return { wch: Math.max(headerLength, maxContentLength) };
  });
};

interface ExportToExcelProps {
  headerItem: string[];
  rowsTable: RowData[];
  title: string;
  nameWorkbook: string;
  filename?: string;
  options?: {
    title: string;
    data: { description: string; value: string | number }[];
  }[];
}

/* Função para exportar para o Excel */
const exportToExcel = ({
  headerItem,
  rowsTable,
  title,
  nameWorkbook,
  filename,
  options,
}: ExportToExcelProps) => {
  /* generate worksheet */
  const worksheet = XLSX.utils.json_to_sheet([]);
  const workbook = XLSX.utils.book_new();

  /* Titulo da planilha */
  XLSX.utils.sheet_add_aoa(worksheet, [[title, ""]], { origin: "A1" });
  // Configura a mesclagem das células A1 e C1, mas deixando B1 fora
  worksheet["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: 2 } }, // Mescla da célula A1 até C1
  ];
  /* fixar o cabecalho  */
  XLSX.utils.sheet_add_aoa(worksheet, [headerItem], { origin: "A3" });

  /* Adicionar dados a partir de A4 */
  XLSX.utils.sheet_add_json(worksheet, rowsTable, {
    origin: "A4",
    skipHeader: true,
  });

  // Aplicar as larguras das colunas
  worksheet["!cols"] = getWithColsExportExcel(headerItem, rowsTable);

  // CRIAR DADOS OPCIONAIS - RESUMO
  if (options && options.length > 0) {
    XLSX.utils.sheet_add_aoa(worksheet, [[], []], { origin: -1 });
    XLSX.utils.sheet_add_aoa(worksheet, [[], []], { origin: -1 });

    options.forEach((option) => {
      // Adicionar resumo ao final da tabela
      XLSX.utils.sheet_add_aoa(worksheet, [[option.title, ""]], { origin: -1 });
      option.data.forEach((row) => {
        XLSX.utils.sheet_add_aoa(worksheet, [[row.description, row.value]], {
          origin: -1,
        });
      });
      XLSX.utils.sheet_add_aoa(worksheet, [[], []], { origin: -1 });
      XLSX.utils.sheet_add_aoa(worksheet, [[], []], { origin: -1 });
    });
  }

  // Definir o nome da sheet limitar o nome em 15 caracteres
  XLSX.utils.book_append_sheet(workbook, worksheet, nameWorkbook.slice(0, 15));
  // Salvar arquivo Excel com nome correto
  XLSX.writeFile(workbook, `${filename ? filename : nameWorkbook}.xlsx`, {
    compression: true,
  });
};

export { getWithColsExportExcel, exportToExcel };
